export const fmtUsd = (n) => {
  const v = parseFloat(n);
  if (v == null || !isFinite(v)) return '—';
  const a = Math.abs(v);
  if (a >= 1e9) return `$${(v / 1e9).toFixed(2)}B`;
  if (a >= 1e6) return `$${(v / 1e6).toFixed(2)}M`;
  if (a >= 1e3) return `$${(v / 1e3).toFixed(2)}K`;
  if (a > 0 && a < 0.01) return `$${v.toPrecision(3)}`;
  return `$${v.toFixed(2)}`;
};

export const fmtPrice = (n) => {
  const v = parseFloat(n);
  if (v == null || !isFinite(v) || v <= 0) return '—';
  if (v < 0.00000001) return `$${v.toExponential(2)}`;
  if (v < 0.01) return `$${v.toPrecision(4)}`;
  return `$${v.toLocaleString('en-US', { maximumFractionDigits: 6 })}`;
};

export const fmtNum = (n, digits) => {
  const v = parseFloat(n);
  if (v == null || !isFinite(v)) return '—';
  const a = Math.abs(v);
  if (a >= 1e9) return `${(v / 1e9).toFixed(2)}B`;
  if (a >= 1e6) return `${(v / 1e6).toFixed(2)}M`;
  if (a >= 1e3) return `${(v / 1e3).toFixed(2)}K`;
  return v.toLocaleString('en-US', { maximumFractionDigits: digits != null ? digits : (a < 1 ? 6 : 2) });
};

export const shortAddr = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : '—');
